module.exports = __webpack_public_path__ + "static/infographic-4d84beb45e0d0b74c315718ae9bfae5d.mp4";